export const AUTH_TOKEN_KEY = 'auth_token'
